import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class CompanyCenterPaths {
  static companyCenter = new EnhancedPath('/company-center');
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: CompanyCenterPaths.companyCenter.path,
      component: lazyWithRetry(() => import('app/pages/companyCenter')),
      exact: true,
      pageCode: PAGE_CODES.COMPANY_CENTER,
    },
  ],
};

export default routesConfig;
